module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.localFootnotes && _vm.allFootnotes) ? _c('div', {
    staticStyle: {
      "margin-left": "2px",
      "display": "inline"
    }
  }, _vm._l((_vm.localFootnotes), function(footnote, index) {
    return _c('span', {
      staticStyle: {
        "font-size": "8px",
        "vertical-align": "super",
        "font-weight": "lighter"
      }
    }, [_vm._v(_vm._s(_vm.allFootnotes.indexOf(footnote) + 1) + _vm._s(index + 1 < _vm.localFootnotes.length ? ',' : '') + " ")])
  }), 0) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65696126"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/approval/field-types/Footnotes.vue
// module id = 696
// module chunks = 0